import { Icon } from '@/src/components/ui';
import { cn } from '@workspace/ui/lib/utils';

type Props = {
  className?: string;
  onClick: () => Promise<void>;
  isTitle?: boolean;
  isProject?: boolean;
};

export const DeleteButton = ({ className, onClick, isTitle }: Props) => {

  return (
    <div
      className={cn(
        'size-10 -top-10 right-1 translate-x-1/2 translate-y-1/2 rounded-full text-center absolute bg-gray-900 text-white col-span-2 transition-all duration-500 ease-in-out cursor-pointer items-center justify-center z-20',
        {'hidden': isTitle},
        className
      )}
      onMouseDown={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      <Icon name="delete-tile" className="size-3.5" />
    </div>
  );
};


export const DeleteDraftButton = ({ className, onClick }: Props) => {
  return (
    <button
      type="button"
      className={cn(
        'absolute -top-10 -right-28 size-10 flex items-center justify-center rounded-full bg-white shadow-lg border border-gray-200 opacity-0 scale-75 group-hover:opacity-100 group-hover:scale-100 transition-all duration-300 ease-in-out z-30',
        className
      )}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      <Icon name="delete-tile" className="size-5 text-black" />
    </button>
  );
}
